import { render, staticRenderFns } from "./DetailLaporanPemasukan.vue?vue&type=template&id=4ef63c82&scoped=true&"
import script from "./DetailLaporanPemasukan.vue?vue&type=script&lang=js&"
export * from "./DetailLaporanPemasukan.vue?vue&type=script&lang=js&"
import style0 from "./DetailLaporanPemasukan.vue?vue&type=style&index=0&id=4ef63c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef63c82",
  null
  
)

export default component.exports